import { customRegex } from './custom-regex.validators';
const caracteresAcceptesParBackend = /^[A-Za-zÀÂÄÇ-ÌÎÏÒÔÖÙÛÜàâäç-ìîïòôöùûü\d_#,.';$()\\\-+=«» ]+$/u;
const caracteresAcceptesParChampsVille = /^[A-Za-zÀÂÄÇ-ÌÎÏÒÔÖÙÛÜàâäç-ìîïòôöùûü_#,.';$()\\\-+=«» ]+$/u;
const separationAvecUnEspace = /^\S+ .+$/;
const codePostalCanadaAvecOuSansEspace = /^[a-zA-Z][0-9][a-zA-Z]\s?[0-9][a-zA-Z][0-9]$/;
const pasJusteDuTexteVide = /^(?!\s*$).+$/;
const numeroTelephone = /^(\d{3})[ -](\d{3})[-](\d{4})$/;
const numeroTelephoneCredit = /^(\d{3})[ -]?(\d{3})[- ]?(\d{4})$/;
const numeroPoste = /^\d+$/;
const courrielValide =
  /^([a-zA-Z0-9!#$%&'*+\-/=?_`{}~]+(\.[a-zA-Z0-9!#$%&'*+\-/=?_`{}~]+)*)@[0-9A-Za-z]([0-9A-Za-z-]{0,61}[0-9A-Za-z])?(\.([A-Za-z]{0,61}[A-Za-z]\.)*([A-Za-z]{2,6}))+$/;
const courrielBancaireValide =
  /^[a-zA-Z0-9.!#$%&'*+\\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
export class CustomValidators {
  static caracteresValidesBackendSeulement = customRegex(caracteresAcceptesParBackend, {
    errorName: 'authorizedCharacters',
  });
  static doitAvoirUneSeparation = customRegex(separationAvecUnEspace, {
    errorName: 'separation',
    pretraitement: (value: string) => `${value}`.trimStart(),
  });
  static ville = customRegex(caracteresAcceptesParChampsVille, { errorName: 'ville' });
  static codePostalCanada = customRegex(codePostalCanadaAvecOuSansEspace, { errorName: 'codepostal' });
  static texteNonBlanc = customRegex(pasJusteDuTexteVide, { errorName: 'textevide' });
  static numeroTelephone = customRegex(numeroTelephone, { errorName: 'numeroTelephone' });
  static numeroTelephoneCredit = customRegex(numeroTelephoneCredit, { errorName: 'numeroTelephone' });
  static numeroPoste = customRegex(numeroPoste, { errorName: 'numeroPoste' });
  static courrielValide = customRegex(courrielValide, { errorName: 'courriel' });
  static courrielBancaireValide = customRegex(courrielBancaireValide, { errorName: 'courrielBancaire' });
}
